function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Input from "./Input";
import US from "./address/USStates";
import CA from "./address/CAProvinces";
var STATES_LOOKUP = {
  CA: CA,
  US: US
};
var defaultProps = {
  countries: ['US'],
  onChange: function onChange() {}
};

var StateInput = function StateInput(_ref) {
  var className = _ref.className,
      _ref$countries = _ref.countries,
      countries = _ref$countries === void 0 ? defaultProps.countries : _ref$countries,
      disabled = _ref.disabled,
      id = _ref.id,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, ["className", "countries", "disabled", "id", "name", "onChange", "placeholder"]);

  var classNames = classnames('custom-select', className);
  var STATES = countries.reduce(function (result, country) {
    var states = STATES_LOOKUP[country] || [];
    return [].concat(_toConsumableArray(result), _toConsumableArray(states));
  }, []);
  return /*#__PURE__*/React.createElement(Input, _extends({
    type: "select"
  }, props, {
    className: classNames,
    disabled: disabled,
    id: id,
    name: name,
    onChange: function onChange(e) {
      return _onChange(e.target.value === '' ? null : e.target.value);
    }
  }), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholder), STATES.map(function (state) {
    return /*#__PURE__*/React.createElement("option", {
      title: state.label,
      value: state.value,
      key: state.value
    }, state.value);
  }));
};

StateInput.displayName = "StateInput";
StateInput.propTypes = {
  className: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.string.isRequired),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string
};
StateInput.defaultProps = defaultProps;
StateInput.displayName = 'StateInput';
export default StateInput;